import watchForHover from 'lib/input-detector';

import config from 'config';
import dev from 'dev';
import layout from 'layout';
import form from 'form';

//import modules  from 'modules';

window.addEventListener('DOMContentLoaded', () => {
    watchForHover();

    layout.init();
    form.init();

    // scroll event header
    window.addEventListener('scroll', () => {
        document.documentElement.classList.toggle('isScrolledToTop', window.scrollY == 0);
    });


    // Main menu items events (hover or click listeners according to the resolution)
    if (window.innerWidth > 1250) {

        document.querySelectorAll('#header nav > ul > li').forEach(li => li.addEventListener('mouseenter', () => {
            const ul = li.parentElement;
            [...ul.children].forEach(li => li.classList.remove('expanded'));
            [...ul.children].forEach(li => li.classList.add('area-plus'));
            li.classList.add('expanded');
            document.querySelector('#header').classList.add("header--dark");
        }));

        document.querySelectorAll('#header nav > ul > li').forEach(li => li.addEventListener('mouseleave', () => {
            const ul = li.parentElement;
            [...ul.children].forEach(li => li.classList.remove('expanded', 'area-plus'));
            document.querySelector('#header').classList.remove("header--dark");
        }));

    } else {

        document.querySelectorAll('#header nav > ul > li').forEach(li => li.addEventListener('click', event => {
            const ul = li.parentElement;
            let cont = li.classList.contains("expanded");
            [...ul.children].forEach(li => li.classList.remove('expanded'));
            let isExpanded = li.matches('.expanded');
            if (cont == false) {
                li.classList.toggle('expanded', !isExpanded);
            }
            document.querySelector('#header').classList.add("header--dark");
        }));

    }


    // Menu toggle event
    document.querySelector('.menu-toggle').addEventListener('click', () => {
        document.querySelector('.main-menu').classList.toggle("expanded");
        document.querySelector('.menu-toggle').classList.toggle("menu-toggle--expanded");
    });



    // disable/enable scroll
    function disableScrolling() {
        var x = window.scrollX;
        var y = window.scrollY;
        window.onscroll = function() { window.scrollTo(x, y); };
    }

    function enableScrolling() {
        window.onscroll = function() {};
    }

    window.addEventListener('scroll', () => {
        if (!window.disableParallax) {
            requestAnimationFrame(updateParallax);
        }
    });


    if (config.dev) {
        dev.init();
    }


});


function updateParallax() {
    document.querySelectorAll('[data-parallax]').forEach(node => {
        const scrollY = window.scrollY,
            screenHeight = window.innerHeight,
            [transformX, transformY] = node.dataset.parallax.split(','),
            boundingRect = node.getBoundingClientRect(),
            scrollMin = scrollY + boundingRect.top - screenHeight,
            scrollMax = scrollY + boundingRect.bottom,
            t = -.5 + (scrollY - scrollMin) / (scrollMax - scrollMin);

        if (t >= -.5 && t <= .5) {
            node.style.transform = `translate3d(${t * transformX}%,${t * transformY}%,0)`;
        }
    });
}